import React, { ComponentProps, forwardRef } from "react";

export const ProdesegVideo = forwardRef<HTMLVideoElement, ComponentProps<"video">>((props, ref) => {
    return <video width="100%" height="100%" controls {...props} ref={ref} />; // NOSONAR
});

ProdesegVideo.displayName = "ProdesegVideo";
